<mat-form-field>
  <mat-label>{{ title() }}</mat-label>
  <textarea matInput rows="2" [formControl]="control()"></textarea>
  @if (control().invalid) {
  <mat-error>
    {{getError()}}
  </mat-error>
  }
</mat-form-field>